const $f666ed68eb02c987$export$17b81730949de002 = "November 3, 2026";


const $aa459f0fea9822fe$var$ACCORDION_LINK_SVG = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>';
function $aa459f0fea9822fe$var$injectAccordionPermalinks() {
    document.querySelectorAll('details.accordion[id]').forEach((details)=>{
        const summary = details.querySelector(':scope > summary.accordion-header');
        if (!summary || summary.querySelector('.accordion-permalink')) return;
        const icon = summary.querySelector('.accordion-icon');
        const a = document.createElement('a');
        a.className = 'accordion-permalink';
        a.href = '#' + details.getAttribute('id');
        a.setAttribute('aria-label', 'Permalink to this section');
        a.setAttribute('title', 'Permalink to this section');
        a.innerHTML = $aa459f0fea9822fe$var$ACCORDION_LINK_SVG;
        a.addEventListener('click', (e)=>{
            e.stopPropagation();
        });
        const wrap = document.createElement('span');
        wrap.className = 'accordion-header-actions';
        wrap.appendChild(a);
        if (icon) summary.insertBefore(wrap, icon);
        else summary.appendChild(wrap);
    });
}
function $aa459f0fea9822fe$var$openAccordionFromHash() {
    const raw = window.location.hash.slice(1);
    if (!raw) return;
    let id = raw;
    try {
        id = decodeURIComponent(raw);
    } catch  {
    /* keep raw */ }
    const el = document.getElementById(id);
    if (el && el.matches('details.accordion')) el.open = true;
}
document.addEventListener('DOMContentLoaded', ()=>{
    const footerUpdated = document.getElementById('footer-last-updated');
    if (footerUpdated) footerUpdated.textContent = (0, $f666ed68eb02c987$export$17b81730949de002) ? `Last updated: ${0, $f666ed68eb02c987$export$17b81730949de002}` : 'Last updated: local preview';
    $aa459f0fea9822fe$var$injectAccordionPermalinks();
    $aa459f0fea9822fe$var$openAccordionFromHash();
    window.addEventListener('hashchange', $aa459f0fea9822fe$var$openAccordionFromHash);
});
document.addEventListener('DOMContentLoaded', ()=>{
    // Smooth scroll for in-page anchors (skip accordion permalinks so the URL hash updates)
    document.querySelectorAll('a[href^="#"]:not(.accordion-permalink)').forEach((anchor)=>{
        anchor.addEventListener('click', function(e) {
            const href = this.getAttribute('href');
            const target = href && document.querySelector(href);
            if (!target) return;
            e.preventDefault();
            target.scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
});
// Mobile Menu Toggle
document.addEventListener('DOMContentLoaded', function() {
    console.log('Initializing mobile menu');
    const mobileMenuButton = document.getElementById('mobile-menu-button');
    const mobileMenu = document.getElementById('mobile-menu');
    console.log('Mobile menu elements:', {
        mobileMenuButton: mobileMenuButton,
        mobileMenu: mobileMenu
    });
    if (mobileMenuButton && mobileMenu) {
        mobileMenuButton.addEventListener('click', function(e) {
            console.log('Menu button clicked');
            e.stopPropagation(); // Prevent event from bubbling up
            mobileMenu.classList.toggle('hidden');
        });
        // Close menu when clicking outside
        document.addEventListener('click', function(event) {
            if (!mobileMenu.contains(event.target) && !mobileMenuButton.contains(event.target)) {
                console.log('Click outside menu detected');
                mobileMenu.classList.add('hidden');
            }
        });
    } else console.error('Mobile menu elements not found');
});


//# sourceMappingURL=repo.f4208ecf.js.map
